import {
  FormControlLabel,
  Grid,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import { useModificationAndSpecificationsQuery } from '@src/queries/ConfiguratorModificationsAndSpecifications.generated'
import { FormattedMessage, useIntl } from 'react-intl'
import { useProductFromQueryParam } from '../../ProductsConfiguration'
import { useCurrentUser } from '@src/utils/useCurrentUser'
import { useMemo } from 'react'
import StyledRadio from '@src/routes/Configurators/utils/ConfiguratorCustomRadioButton'
import { transformString } from '../../utils'
import useFormikHelper from '../../useFormikHelper'
import messages from '../../../../messages'

const ProbeType = () => {
  const formik = useFormikHelper()
  const intl = useIntl()
  const product = useProductFromQueryParam()

  const { isCustomerServiceRep, isCustomProductCSR, userIsLoggedIn } =
    useCurrentUser()

  const { data } = useModificationAndSpecificationsQuery({
    variables: {
      product: {
        productType: product,
        isCSR: isCustomerServiceRep,
        isCSRSupervisor: isCustomProductCSR,
        isRegUser: userIsLoggedIn,
      },
    },
    ssr: false,
    fetchPolicy: 'cache-first',
  })

  const probeList = useMemo(() => {
    return data?.getModificationAndSpecifications?.specifications?.find(
      (data) => data?.categoryName === 'probeType'
    )?.specificationModifications
  }, [data])

  const onProbeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setOligoFieldValue('probeType', e.target.value, false)
    const fieldList = [
      'threeMod',
      'internalMod',
      'fiveMod',
      'five-reporter-three-quencher',
      'sequence',
      'name',
      'baseCount',
      'molecularWeight',
      'secondaryStructure',
      'primerDimer',
      'meltingTemperature',
      'gcContent',
      'displayPageError',
    ]
    if (formik.allValues.applyToNextOligos) {
      formik.setFieldTouched('amount', true)
    } else {
      formik.setOligoFieldValue('tubes', '1', false)
      fieldList.push('amount')
      formik.setFieldTouched('amount', false)
    }
    fieldList.map((field) => formik.setOligoFieldValue(field, '', false))
    formik.setFieldTouched('name', false)
    formik.setFieldTouched('sequence', false)
    formik.setFieldValue('displayPageError', false)
    formik.setErrors({})
    formik.setTouched({})
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h2">
          <FormattedMessage id="PROBE_TYPE" defaultMessage="Probe Type" />
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <RadioGroup
          name="probeType"
          row
          value={
            formik.selectedOligoValues?.probeType ||
            transformString('DUAL_LABELED')
          }
          onChange={onProbeChange}
        >
          {probeList?.map((item) => (
            <FormControlLabel
              key={item.value}
              value={transformString(item.value)}
              control={<StyledRadio isConfiguratorsRedesign="true" />}
              label={intl.formatMessage(messages[item.displayName])}
            />
          ))}
        </RadioGroup>
      </Grid>
    </Grid>
  )
}

export default ProbeType
